var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"your-page"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-9081865004858391","data-ad-slot":"8481329516","data-ad-format":"auto","data-full-width-responsive":"true"}})])])])
}]

export { render, staticRenderFns }